export enum WorkflowDefinitionType {
  RELEASE = 'RELEASE',
  DRAFT = 'DRAFT',
}
